<template>
  <div class="container flex flex-col items-center mx-auto my-8 lg:mt-[100px]">
    <h1 class="text-[17px] sm:text-[28px] font-bold text-center mb-2 text-[28px] lg:mb-14 text-blue-600">CÁC DỊCH VỤ CUNG CẤP</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">1. Thiết Kế Website Bán Hàng – Tăng Doanh Số, Tiếp Cận Khách Hàng Dễ Dàng</h1>
        <p class="text-gray-600 mb-4">Thiết kế website bán hàng chuyên nghiệp, chuẩn SEO, dễ dàng quản lý sản phẩm và tối ưu hóa đơn hàng…</p>
        <router-link to="/thiet-ke-website-ban-hang-ca-nhan">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>

      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">2. Thiết Kế Landing Page & Website Doanh Nghiệp – Chuyên Nghiệp & Chuẩn SEO</h1>
        <p class="text-gray-600 mb-4">Thiết kế website giới thiệu về công ty, doanh nghiệp chuẩn SEO. Xây dựng trang đích thu hút, tối ưu hóa chuyển đổi khách hàng…</p>
        <router-link to="/thiet-ke-website-landing-page">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>

      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">3. Xây Dựng Website Thương Mại Điện Tử – Giải Pháp Kinh Doanh Online Hiệu Quả</h1>
        <p class="text-gray-600 mb-4">Phát triển nền tảng mua sắm trực tuyến mạnh mẽ và an toàn với thiết kế website thương mại điện tử chuyên nghiệp…</p>
        <router-link to="/thiet-ke-website-thuong-mai-dien-tu">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>

      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">4. Thiết Kế Website Blog Cá Nhân – Lưu Giữ Kỷ Niệm, Chia Sẻ Câu Chuyện</h1>
        <p class="text-gray-600 mb-4">Tạo một website cá nhân cho bạn, cho gia đình, nơi lưu lại những khoảnh khắc đẹp và đáng nhớ…</p>
        <router-link to="/thiet-ke-website-blog">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>

      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">5. Dịch Vụ Hỗ Trợ Đồ Án Website Cho Sinh Viên – Dễ Hiểu, Dễ Triển Khai</h1>
        <p class="text-gray-600 mb-4">Cung cấp giải pháp và hướng dẫn chi tiết cho đồ án thiết kế website của sinh viên với chi phí thấp…</p>
        <router-link to="/thiet-ke-do-an-website">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>

      <div class="bg-white p-6 rounded-lg shadow-md">
        <h1 class="text-xl font-semibold mb-2">6. Quảng Cáo Facebook & Dịch Vụ Tương Tác – Tăng Hiệu Quả, Mở Rộng Tiếp Cận</h1>
        <p class="text-gray-600 mb-4">Tiếp cận đúng mục tiêu, giúp website của bạn có nhiều lượt traffic hiệu quả hơn…</p>
        <router-link to="/chay-quang-cao-website">
          <button @click="saveScrollPosition" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Chi tiết</button>
        </router-link>
      </div>
    </div>

    <!-- Related Resources Section -->
    <div class="mt-12 bg-gray-50 p-8 rounded-lg">
      <h2 class="text-2xl font-bold text-blue-600 mb-6 text-center">Tài Nguyên Liên Quan</h2>
      <div class="grid md:grid-cols-3 gap-6">
        <div class="bg-white p-6 rounded-lg shadow-md text-center">
          <h3 class="text-lg font-semibold mb-3">Quy Trình Làm Việc</h3>
          <p class="text-gray-600 mb-4">Tìm hiểu quy trình 6 bước thiết kế website chuyên nghiệp</p>
          <router-link to="/quy-trinh-thiet-ke-website">
            <button class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Xem chi tiết</button>
          </router-link>
        </div>
        <div class="bg-white p-6 rounded-lg shadow-md text-center">
          <h3 class="text-lg font-semibold mb-3">Cẩm Nang Website</h3>
          <p class="text-gray-600 mb-4">Hướng dẫn SEO, bảo mật và tối ưu tốc độ website</p>
          <router-link to="/web-guide">
            <button class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Đọc ngay</button>
          </router-link>
        </div>
        <div class="bg-white p-6 rounded-lg shadow-md text-center">
          <h3 class="text-lg font-semibold mb-3">Blog Kiến Thức</h3>
          <p class="text-gray-600 mb-4">Chia sẻ kinh nghiệm về thiết kế website và SEO</p>
          <router-link to="/blog">
            <button class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Khám phá</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  const saveScrollPosition = () => {
    sessionStorage.setItem('scrollPosition', window.scrollY); // Lưu vị trí cuộn hiện tại
  }
</script>
